import { ActionIcon, Anchor, Badge, Group, Text, Tooltip } from "@mantine/core";
import { IconFileArrowRight } from "@tabler/icons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { FinanceableApi } from "../../apis";
import { ColumnType, Table } from "../../components/table";
import { Tag } from "../../components/tags";
import { IGeneral } from "../../interfaces/IGeneral";
import { IReference } from "../../models/General";
import { currencyFormat } from "../../utils";
import { getLbfProgramReduce } from "../../store/Programs";

export const LbfPossibleProgramList = () => {
  const navigate = useNavigate();
  const { programStatus } = useSelector((state: { general: IGeneral }) => state.general);
  const dispatch = useDispatch();

  const columns = useHeader({
    programStatus,
    onClick: (key, item) => {
      switch (key) {
        case "details":
          navigate(`/invoice-possible/${item.id}/LBF`);
          dispatch(getLbfProgramReduce(item));
          break;

        default:
          break;
      }
    },
  });

  return (
    <div>
      <Table
        minWidth={2400}
        name="financeable.program.lbf.list"
        columns={columns}
        filters={{ financeType: "LBF" }}
        loadData={(data) => FinanceableApi.programList(data!)}
      />
    </div>
  );
};

const useHeader = ({ onClick, programStatus }: { onClick: (e1: string, e2: any) => void; programStatus: IReference[] }): ColumnType<any>[] => [
  {
    title: "#",
    render: (_r, index) => `${index + 1}`,
    width: "30px",
  },
  {
    title: "Үйлдэл",
    render: (record) => {
      return (
        <Tooltip label="Боломжит нэхэмжлэх" position="bottom">
          <ActionIcon variant="light" color={"golomt"} onClick={() => onClick("details", record)}>
            <IconFileArrowRight />
          </ActionIcon>
        </Tooltip>
      );
    },
  },
  {
    title: "Хөтөлбөр нэр",
    render: (record) => {
      return (
        <Text w="max-content">
          <Text>{record?.name || "-"}</Text>
          <Anchor># {record?.refCode || "-"}</Anchor>
        </Text>
      );
    },
  },
  {
    title: "Хөтөлбөрийн төрөл",
    dataIndex: "lbfProductType",
    render: (record) => {
      return <Text w="max-content">{record.lbfProductType || "-"}</Text>;
    },
  },
  {
    title: "Хөтөлбөрийн анкор эсэх",
    render: (record) => {
      return (
        <Badge size="sm" variant="outline" color={record.isProgramAnchor ? "green.5" : "red.5"}>
          {record.isProgramAnchor ? "Тийм" : "Үгүй"}
        </Badge>
      );
    },
  },
  {
    title: "Бүтээгдэхүүн",
    render: (record) => {
      return record?.lbfProduct ? (
        <Text w="max-content">
          <Text w="max-content">{record?.lbfProduct?.name || "-"}</Text> <Anchor># {record?.lbfProduct?.refCode || "-"}</Anchor>
        </Text>
      ) : (
        "-"
      );
    },
  },
  {
    title: "Хөтөлбөр статус",
    render: (record) => {
      return Tag(
        programStatus.find((item: IReference) => item.code === record.lbfProgramStatus)?.color || "",
        programStatus.find((item: IReference) => item.code === record.lbfProgramStatus)?.name || "-",
      );
    },
  },
  {
    title: "Нийт баталсан лимит",
    render: (record) => (
      <Group position="right">
        <Text w={"max-content"} align="end">
          {currencyFormat(record?.lbfProgramLimit || 0)}
        </Text>
      </Group>
    ),
  },
];
